import { render, staticRenderFns } from "./advanced.vue?vue&type=template&id=0313f655&scoped=true&"
import script from "./advanced.vue?vue&type=script&lang=ts&"
export * from "./advanced.vue?vue&type=script&lang=ts&"
import style0 from "./advanced.vue?vue&type=style&index=0&id=0313f655&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0313f655",
  null
  
)

export default component.exports